import React, { useState } from "react";
import "../../../components/table/table.css";
import {
  FaDownload,
  FaEye,
  FaFileAlt,
  FaMinusCircle,
  FaPlusCircle,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Button, Col, Input, Row } from "reactstrap";

const Reports = () => {
  const [showTable, setShowTable] = useState(true);
  const navigate = useNavigate();
  // const handleClick = () => {
  //     navigate('/Hrcorrection');
  // };

  const [selectedReportType, setSelectedReportType] = useState("all");
  const [selectedReportEmployee, setSelectedReportEmployee] = useState("all");
  const reportData = [
    {
      id: 1,
      name: "Attendance Reports",
      navigation: "/Attendance/AttendanceReport",
      type: "attendance",
    },
    {
      id: 2,
      name: "Salary Reports",
      navigation: "/ems/PaySlipReport",
      type: "salaryreport",
    },
    {
      id: 3,
      name: "Service Request Report",
      navigation: "/support/report/IssueReport",
      type: "ServiceRequestReport",
    },
    {
      id: 4,
      name: "Daily Task Reports",
      navigation: "/ems/DailyTaskReport",
      type: "DailyTaskReports",
    },
  ];

  return (
    <div className="leave-wrapper">
      <div className="leave-header">
        <div className="leave-title">
          <FaFileAlt className="leave-icon" />
          <span> Reports</span>
        </div>
        <div className="leave-actions">
          <button className="view-all-btn">View All</button>
          <button
            className="icon-toggle-btn"
            onClick={() => setShowTable(!showTable)}
          >
            {showTable ? <FaMinusCircle /> : <FaPlusCircle />}
          </button>
        </div>
      </div>

      {showTable && (
        <>
          <Row className="m-2">
            <Col md={4} className="mb-2">
              <Input
                type="select"
                value={selectedReportType}
                onChange={(e) => setSelectedReportType(e.target.value)}
              >
                <option value="all">All Report Types</option>
                <option value="attendance">Attendance Reports</option>
                <option value="salaryreport">Salary Reports</option>
                <option value="ServiceRequestReport">
                  Service Request Report
                </option>
                <option value="DailyTaskReports">Daily Task Reports</option>
              </Input>
            </Col>
          </Row>
          <div
            className="table-container"
            style={{ height: "100%", display: "flex", flexDirection: "column" }}
          >
            <table className="leave-table">
              <thead>
                <tr>
                  <th>Report Name</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {reportData
                  .filter((report) => {
                    const typeMatch =
                      selectedReportType === "all" ||
                      report.type === selectedReportType;
                    return typeMatch;
                  })
                  .map((report) => (
                    <tr key={report.id}>
                      <td>{report.name}</td>
                      <td>
                        <div className="d-flex">
                          <Button color="info" size="sm" className="me-1">
                            <FaEye
                              className="me-1"
                              onClick={() => {
                                navigate(report.navigation);
                              }}
                            />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div style={{ flex: "0 0 10px" }}></div>
          </div>
        </>
      )}
    </div>
  );
};

export default Reports;
